import { Col, Divider, Drawer, Row } from "antd";

import React from "react";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper" style={{ padding: "5px 0", lineHeight: "20px" }}>
    <span style={{ fontWeight: "bold" }}>{title}</span>: {content || "N/A"}
  </div>
);

function TaskSumbission({ close, open, data }) {
  const userData = data?.userData;
  const weekId = `week${data?.schedule?.id}`;

  const schedule = data?.schedule;
  const taskDetail = userData?.tasks[weekId];

  if (!userData || !taskDetail || JSON.stringify(userData.tasks[weekId]) == JSON.stringify({})) {
    return (
      <Drawer width={640} placement="right" closable={true} onClose={() => close()} open={open}>
        <h1 className="site-description-item-profile-p" style={{ marginBottom: 24 }}>
          No Task Found ❌
        </h1>
      </Drawer>
    );
  }

  return (
    <Drawer width={640} placement="right" closable={true} onClose={() => close()} open={open}>
      <h1 className="site-description-item-profile-p" style={{ marginBottom: 24 }}>
        Day {schedule.id}
      </h1>
      <p className="site-description-item-profile-p">Personal</p>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Name" content={userData.name} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Email" content={userData.email} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Phone" content={userData.phone} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="City" content={userData.city || "N/A"} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="School" content={userData.school || "N/A"} />
        </Col>
      </Row>

      <Divider />
      <p className="site-description-item-profile-p">Task Details</p>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Time Spent⏳" content={`${taskDetail.timeSpent || 0} hours `} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Description" content={taskDetail.description} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem
            title="Task Document Link"
            content={
              taskDetail.fileUrl ? (
                <a href={taskDetail.fileUrl} target="_blank" rel="noopener noreferrer">
                  {taskDetail.fileUrl}
                </a>
              ) : (
                "N/A"
              )
            }
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Key Learning" content={taskDetail.keyLearnings} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem title="Challenges faced" content={taskDetail.challenges} />
        </Col>
      </Row>
    </Drawer>
  );
}

export default TaskSumbission;
